module.exports = __webpack_public_path__ + "static/img/rocket_league-portrait.04d0cfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/rocket-league/rocket_league-portrait.png
// module id = 8RiV
// module chunks = 35